<div class="navbar navbar-expand navbar-custom">
    <div class="container-fluid">
        <button type="button" class="menu-grid-button" (click)="close()" title="Close the menu" aria-label="Close the menu">
            <i [attr.data-feather]="'x'" appFeatherIcon></i>
        </button>

        <a routerLink="/" class="navbar-brand mr-0 mr-md-2 logo d-none d-sm-block" (click)="close()">
            <img src="assets/images-bundle/logo.svg" alt="Cinemapp logo" height="24" />
        </a>

        <input #filterInput type="search" class="form-control grid-menu-filter ml-auto" placeholder="Find a page"
            aria-label="Find a page" [value]="query" (input)="filter(filterInput.value)" (keydown.enter)="openFirst()" />
    </div>
</div>

<div class="container-fluid grid-menu-body">
    <ng-container *ngIf="!query">
        <h6 class="grid-menu-heading">Recents</h6>
        <div class="grid-menu-recents" *ngIf="recents.length; else noRecents">
            <a *ngFor="let item of recents; trackBy: trackByLink" class="grid-menu-recent" [routerLink]="item.link" (click)="open(item.link, $event)">
                <i [attr.data-feather]="item.icon" appFeatherIcon></i>
                <span><span class="grid-menu-recent-section" *ngIf="item.section">{{item.section}}</span>{{item.label}}</span>
            </a>
        </div>
        <ng-template #noRecents>
            <p class="text-muted">The last 7 pages you open from this menu show up here.</p>
        </ng-template>

        <h6 class="grid-menu-heading">All pages</h6>
    </ng-container>

    <div class="grid-menu-grid">
        <div class="grid-menu-tile" *ngFor="let section of sections; trackBy: trackByLink">
            <a class="grid-menu-tile-head" [routerLink]="section.link" (click)="open(section.link, $event)">
                <span class="grid-menu-icon"><i [attr.data-feather]="section.icon" appFeatherIcon></i></span>
                {{section.label}}
            </a>
            <ul *ngIf="section.subItems.length" class="grid-menu-sublinks">
                <li *ngFor="let sub of section.subItems; trackBy: trackByLink">
                    <a [routerLink]="sub.link" (click)="open(sub.link, $event)">{{sub.label}}</a>
                </li>
            </ul>
        </div>
    </div>

    <p class="text-muted" *ngIf="!sections.length">No page matches “{{query}}”.</p>
</div>
